export default {
  formatMonthYear: state => {
    let v = state.month[state.d.getMonth()].split('_')
    return v[0] + " " + v[1]
  },
  formatNextMonthYear: state => (id) => {
    let v = state.month[state.d.getMonth()].split('_')
    return v[0] + " " + v[1]
  },

  formatSlug: state => {
    let v = state.month[state.d.getMonth()].split('_')
    return v[0] + "-" + v[1]
  },

}
